/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { ApiReferencePage } from '@/pages/ApiReference/ApiReferencePage';

export function ApiReferenceRoute() {
  return <ApiReferencePage />;
}
